<era-panel>
  <era-panel-header>
    @if (user(); as currentUser) {
      <era-title [isDetail]="true">
        <span title>Membership of
          <span>{{ currentUser.displayName }}</span>
        </span>
        <era-context-menu [isEditing]="editEnabled()"
                          (selectedEdit)="toggleEdit()"
                          canEdit="true">
          <button ngbDropdownItem
                  (click)="addGroup()">Add group</button>
        </era-context-menu>
      </era-title>
    }
  </era-panel-header>
  <era-security-membership-list-group-items [isEditing]="editEnabled()"></era-security-membership-list-group-items>
</era-panel>